import React from "react";
import { useTranslation } from "react-i18next";

import { useAppContext } from "@/contexts";
import { type PhqOption, usePhq } from "@/hooks";
import { shouldAskBaselineOutcomes } from "@/utils/survey/outcomes";

import { QuestionComponentProps, QuestionDefinition } from "../../../Question";
import { MultipleChoiceQuestion } from "../../core";

const QUESTION_ID = "phq3";

declare module "@/contexts" {
  interface SurveyAnswers {
    phq3?: PhqOption;
  }
}

const Phq3Question: React.FC<QuestionComponentProps> = ({
  onClickBack,
  onClickNext,
  surveyAnswers,
}) => {
  const { surveyMetadata } = useAppContext();
  const { phqOptions } = usePhq();
  const { t } = useTranslation();

  const questionText =
    surveyMetadata?.name === "RECURRING_OUTCOMES"
      ? t("phq3.questionText.recurringOutcomes")
      : t("phq3.questionText.enrollment");

  return (
    <MultipleChoiceQuestion
      onClickBack={onClickBack}
      onClickNext={onClickNext}
      options={phqOptions}
      questionId={QUESTION_ID}
      questionText={questionText}
      selectedItem={surveyAnswers[QUESTION_ID] || ""}
    />
  );
};

export const Q_PHQ_3: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: [
    "WEIGHT",
    "MOOD",
    "DPP",
    "DIABETES_LIFESTYLE",
    "MED",
    "NMPBA",
  ],
  shouldShowQuestion: ({ partnerInfo }) =>
    shouldAskBaselineOutcomes(partnerInfo),
  component: Phq3Question,
};

export const Q_RETRIAGE_PHQ_3: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: ["MED", "NMPBA"],
  shouldShowQuestion: () => true,
  component: Phq3Question,
};
